"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TIMER_COLORS = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));
var _differenceInMilliseconds = _interopRequireDefault(require("date-fns/differenceInMilliseconds"));
var _date = require("../../../../utils/date/date");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("./constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TIMER_COLORS = exports.TIMER_COLORS = {
  RED: '#d0021b',
  YELLOW: '#ddd109',
  GREEN: '#00ae46'
};
var Timer = function Timer(_ref) {
  var className = _ref.className,
    subtrahendTime = _ref.subtrahendTime,
    seconds = _ref.seconds,
    type = _ref.type;
  var timerInterval = (0, _react.useRef)();
  var _useState = (0, _react.useState)((0, _differenceInMilliseconds["default"])(new Date(), (0, _parseISO["default"])(subtrahendTime))),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    time = _useState2[0],
    setTime = _useState2[1];
  (0, _react.useEffect)(function () {
    var updateTimer = function updateTimer() {
      setTime((0, _differenceInMilliseconds["default"])(new Date(), (0, _parseISO["default"])(subtrahendTime)));
    };
    updateTimer();
    var timerInterval = setInterval(updateTimer, 5000);
    return function () {
      clearInterval(timerInterval);
    };
  }, [subtrahendTime]);
  var timerBg = function timerBg() {
    var sla_ltt = seconds * 1000;
    if (time <= sla_ltt / 2) return TIMER_COLORS.GREEN;
    if (sla_ltt / 2 < time && time < sla_ltt) return TIMER_COLORS.YELLOW;
    if (time >= sla_ltt) return TIMER_COLORS.RED;
    return TIMER_COLORS.GREEN;
  };
  return /*#__PURE__*/_react["default"].createElement(StyledTimerWrapper, null, "".concat(type, ": "), /*#__PURE__*/_react["default"].createElement(StyledTimer, {
    className: className,
    $bgColor: timerBg(),
    "data-testid": type === 'SLA' ? _constants.SLA_TIMER_TEST_ID : _constants.LTT_TIMER_TEST_ID
  }, (0, _date.formatMilliseconds)(time)));
};
var StyledTimerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Timer__StyledTimerWrapper",
  componentId: "sc-kneubo-0"
})(["display:inline-block;"]);
var StyledTimer = _styledComponents["default"].div.withConfig({
  displayName: "Timer__StyledTimer",
  componentId: "sc-kneubo-1"
})(["display:inline-block;padding:2px 6px;background:", ";color:#fff;font-weight:600;font-size:10px;border-radius:4px;"], function (_ref2) {
  var $bgColor = _ref2.$bgColor;
  return $bgColor;
});
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Timer);